/**
 * Created by bob.gear on 10/03/2015.
 * 
 */
angular.module('EICDataStream3.notificationCentre', ["EICDataStream3.queryBuilder"])
  .controller('NotificationCentreController', ['$scope', 'dialogs', 'watchService', 'themeService',
    function ($scope, dialogs, watchService, themeService) {
      $scope.componentName = "NotificationCentreController";

      $scope.theme = themeService;

      $scope.title = 'Project Watches';
      $scope.watches =[];

      $scope.isEditing= false;
      $scope.isAdding= false;


      $scope.viewWatch = function(watch){
        watchService.gotoWatch(watch);
      };


      $scope.loadWatchList = function(sort) {
        watchService.getWatches(sort)
          .then(function (response, e) {
            $scope.watches = response.data;
            $scope.watches.map(function (item) {
              item.name = item.name.replace(/\s{2,}/g, ' ');
              item.originalName = item.name;
              item.validated = !watchService.nameDuplicated($scope.watches, item.name);
            });
          })
          .catch(function (e1, e2, e3) {
            var j = 0;
          });
      };


      $scope.saveNotification = function(){
        $scope.isEditing = false;
        $scope.isAdding = true;
      };


      $scope.saveNewNotification = function(notification){
        $scope.isAdding = false;
        notification.isNew = false;
      };


      $scope.editNotification = function(notification){
        $scope.isEditing = true;
      };


      $scope.newNotification = function(){
        $scope.isAdding = true;
        $scope.notifications.push({
          isNew: true,
          isEnabled: true
        });
      };


      $scope.enableWatch =  function(watch){
        watchService.enableWatch(watch);
        //
        // w = getWatchByID($scope.watches, watch.guid);
        // w.nextNotification = nextNotification;
      };


      function getWatchByID(arr, value) {

        for (var i=0, iLen=arr.length; i<iLen; i++) {

          if (arr[i].guid == value) return arr[i];
        }
      };

      $scope.deleteModeActivated =  function(){
        $scope.isDeleting = true;

        $scope.watches.forEach(function(watch){
          watch.cssClass = "fa fa-circle-thin fa-lg";
        });
      }

      $scope.deleteWatch =  function(id){
        // stick in a warning dialog and only proceed with the delete
        // if the user confirms
       // $scope.openDeleteMemberNoteDialog = function(id) {
          var dlgDeleteWatch = dialogs.create('/app/notifications/deleteWatchConfirmation.dialog.html',
            'deleteWatchConfirmationDialogCtrl',
            { watchID: id },
            {
              size:'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );

        
          dlgDeleteWatch.result.then(function(data){
            // assuming the Watch was successfully delete, remove it from the array of watches
            for( i=$scope.watches.length-1; i>=0; i--) {
              if( $scope.watches[i].guid == data.watchID) {
                $scope.watches.splice(i,1);
                break;
              }
            }

          },function(){
            // Action upon failure
          });
        };


      // ------------------------------------------------------------------
      // functions for editing watches
      // ------------------------------------------------------------------
      $scope.selectForDelete = function (item) {
        var returnClass = {
          'fa fa-circle-thin fa-lg': $scope.isDeleting && !item.isDeleting,
          'fa fa-ban fa-lg': $scope.isDeleting && item.isDeleting,
          'alert-text': item.isDeleting,
          'normal-text': !item.isDeleting
        };

        // item.cssClass = "dummyClass";

        // item.isDeleting = !item.isDeleting;

        // if ($scope.isDeleting) {
        //   item.cssClass = "fa fa-circle-thin fa-lg";
        // }
        // if ($scope.isDeleting && item.isDeleting) {
        //   item.cssClass = "fa fa-ban fa-lg";
        // }

        return returnClass;
      };





      $scope.noWatchesToDelete = function () {
        if (!$scope.isDeleting) return true;

        var any = true;
        $scope.watches.map(function (item) {
          if (item.isDeleting) {
            any = false;
          }
        });
        return any;
      };


      $scope.btnCancel = function () {
        $scope.isDeleting = false;
        $scope.isEditing = false;
        $scope.watches.forEach(function (item) {
          item.isDeleting = false;
          item.isEditing = false;
          item.label = item.originalLabel;
          item.cssClass = "";
        });
      };


      $scope.btnDelete = function () {
        $scope.isDeleting = false;
        $scope.watches.map(function (item) {
          if (item.isDeleting) {
            watchService.deleteWatch(item.guid).then(function(){
              $scope.loadWatchList();
            });
          }
        });
      };


      $scope.markChanged = function(watch){
        watch.isEdited = true;
      };


      $scope.nameChanged = function(watch) {
        watch.name = watch.name.replace(/\s{2,}/g, ' ');
        var changed = (watch.name == watch.originalName);

        watch.isEdited = changed ? false : true;
        watch.validated = !watchService.nameDuplicated($scope.watches, watch.name);
      };


      $scope.notificationFrequencyChanged = function(watch){
        $scope.markChanged(watch);
        watch.nextNotification = watchService.calculateNextNotification(watch);
      };


      $scope.btnSaveChanges = function () {
        $scope.isEditing = !watchService.saveChanges($scope.watches);
      };



      $scope.$on("SORT_CHANGED", function (e, sort) {
        $scope.loadWatchList(sort);
        console.log("Sort Changed to: " + sort.sortField + "  desc:" + sort.sortDesc);
      });

      $scope.loadWatchList();

    }])
  .service('watchService', ['$http', '$state',
    function($http, $state){
      var watchService = this;

      // call back to the server to actually create the watch
      // and return the promise
      this.createProjectWatch = function(projectWatchParams){
        return $http.post('/api/projectwatch', projectWatchParams);
      };


      this.getWatches = function (sort) {
        var sortQuerystring = "";
        if (sort) sortQuerystring = "?sortField=" + sort.sortField + "&sortDesc=" + sort.sortDesc;
        return $http.get("/api/projectWatch" + sortQuerystring);
      };


      this.calculateNextNotification = function(watch){
        var isEnabled = watch.isEnabled;
        var schedule = watch.notificationFrequency;

        var nextNotification = null;
        var today = new Date(Date.now());
        var todaysDayNumber = today.getDay();

        if(isEnabled) {
          if (schedule == "Daily") {
            // next run is today
            nextNotification = today.toISOString();
          }
          else if (schedule == "Weekly") {
            // Calculate date of next saturday. if today is saturday, set the next run to be the same day
            // var nextNotification = today.AddDays(DayOfWeek.Saturday - todaysDayNumber);
            nextNotification =  new Date(today.setDate(today.getDate() + (6 - todaysDayNumber))).toISOString();
          }
        }
        return nextNotification;
      }


      this.enableWatch = function (watch) {
        watch.nextNotification  = watchService.calculateNextNotification(watch);

        return $http.patch("/api/projectWatch/properties/"+watch.guid,
          [
            {op: "replace", path: "/isEnabled", value: watch.isEnabled},
            {op: "replace", path: "/NextNotification", value: watch.nextNotification}
          ],
          {
            headers:  { "Content-Type": "application/json-patch+json" }
          });
      };


      this.nameDuplicated = function(list, name){
        var duplicates = 0;
        list.map(function(item){
          if(item.name.toLowerCase() == name.toLowerCase()) duplicates++;
        });

        return (duplicates > 1); // that  is, not counting the item itself
      };


      this.saveChanges = function(watches) {
        // Stage 1 validate that
        //  a. each list has a name
        //  b. the name has not already been used
        // if these two conditions are not met, highlight the offending names,
        // put up a message and abort before actually renaming the lists
        if (validateWatches(watches)){
          return updateAll(watches);
        }
        else
          return false;
      };


      var validateWatches = function(watches){
        var allOK = true;

        watches.map(function (item) {
          // before performing the validation, remove multiple spaces
          // from the proposed name, replacing with single spaces
          item.name = item.name.replace(/\s{2,}/g, ' ');

          if (item.name == "" || item.name == " " || watchService.nameDuplicated(watches, item.name)) {
            item.validated = false;
            allOK = false;
          }
          else {
            item.validated = true;
          }
        });
        return allOK;
      };


      var updateAll = function(watches){
        watches.map(function (item) {
          if (item.isEdited) {
            watchService.update(item);
            item.isEdited = false;
          }
        });
        return true;
      };


      this.update = function (watch) {
        watch.nextNotification  = this.calculateNextNotification(watch);
        var notificationFrequency = translateNotificationFrequency(watch);

        return $http.patch("/api/projectWatch/properties/"+ watch.guid,
          [
            {op: "replace", path: "/WatchName", value: watch.name},
            {op: "replace", path: "/Description", value: watch.description},
            {op: "replace", path: "/NextNotification", value: watch.nextNotification},
            {op: "replace", path: "/NotificationFrequency", value: notificationFrequency}
          ],
          {
            headers:  { "Content-Type": "application/json-patch+json" }
          });
      };

      var  translateNotificationFrequency = function(watch){
        switch(watch.notificationFrequency){
          case 'Daily': return 1;
          case 'Weekly' :return 7;
          default: return 7;
        }
      }

      this.deleteWatch = function (id) {
        return $http.delete("/api/projectWatch/"+id )
      };


      this.gotoWatch = function(watch){
        $state.go("projectWatch", {guid:watch.guid, name:watch.name.urlEncode()})
      };


      this.addProjectsToWatch = function(projectWatchParams) {
        var watchGuid = projectWatchParams.selectedProjectWatch.guid;
        var projectIDs = projectWatchParams.projectIDs;
        return $http.patch("/api/projectWatch/projects/" + watchGuid + "?operation=addProjects", projectIDs
          //[
          //  { op: "add", path: "/ProjectWatchProjects/0", value: {ProjectWatchGuid: watchGuid, ProjectID: projectIDs[0]}  },
          //  { op: "add", path: "/ProjectWatchProjects/1", value: {ProjectWatchGuid: watchGuid, ProjectID: projectIDs[1]}  }
          //],
          //{
          //  headers:  { "Content-Type": "application/json-patch+json" }
          //}
        );


      };


      this.stopWatchingProjects = function(projectWatchParams){
        var watchGuid = projectWatchParams.watchGuid;
        var projectIDs = projectWatchParams.projectIDs;
        return $http.patch("/api/projectWatch/projects/" + watchGuid + "?operation=removeProjects", projectIDs
          //[
          //  { op: "add", path: "/ProjectWatchProjects/0", value: {ProjectWatchGuid: watchGuid, ProjectID: projectIDs[0]}  },
          //  { op: "add", path: "/ProjectWatchProjects/1", value: {ProjectWatchGuid: watchGuid, ProjectID: projectIDs[1]}  }
          //],
          //{
          //  headers:  { "Content-Type": "application/json-patch+json" }
          //}
        );
      };


      this.restoreProject = function (watchGuid, projectID) {
        var projectIDs = [];
        projectIDs.push(projectID);
        return $http.patch("/api/projectWatch/projects/" + watchGuid + "?operation=restoreProject", projectIDs);
      };

    }])// end service(watchService)
  .controller('deleteWatchConfirmationDialogCtrl', ['$scope','$uibModalInstance', 'data', 'watchService',
    function($scope,$uibModalInstance,data, watchService){
      //-- data --//
      $scope.watchID = data.watchID;

      //-- Methods --//

      $scope.cancel = function(){
        $uibModalInstance.dismiss('Canceled');
      }; // end cancel

      $scope.delete = function(id){
        return watchService.deleteWatch(id)
          .then(function(){
            $uibModalInstance.close(data);
        });

      }; // end delete

      $scope.hitEnter = function(evt){
        if(angular.equals(evt.keyCode,13) && !(angular.equals($scope.user.name,null) || angular.equals($scope.user.name,'')))
          $scope.delete();
      };
    }]);// end controller(deleteWatchConfirmationDialogCtrl)
